var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94591 8.19148L5.07704 9.41797V16.3914H6.6155V9.37294L5.94591 8.19148ZM5.33014 6.35814C5.6903 5.84976 6.42955 5.88944 6.73802 6.43372L8.03574 8.72352C8.11313 8.86006 8.15396 9.01585 8.15396 9.17457V17.1153C8.15396 17.6039 7.77513 18 7.30781 18H4.38473C3.91741 18 3.53857 17.6039 3.53857 17.1153V9.17907C3.53857 8.98944 3.59684 8.80482 3.7048 8.65244L5.33014 6.35814Z",
    fill: "#1A2021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0995 8.19148L11.2306 9.41797V16.3914H12.7691V9.37294L12.0995 8.19148ZM11.4837 6.35814C11.8439 5.84976 12.5831 5.88944 12.8916 6.43372L14.1893 8.72352C14.2667 8.86006 14.3075 9.01585 14.3075 9.17457V17.1153C14.3075 17.6039 13.9287 18 13.4614 18H10.5383C10.071 18 9.69214 17.6039 9.69214 17.1153V9.17907C9.69214 8.98944 9.75041 8.80482 9.85836 8.65244L11.4837 6.35814Z",
    fill: "#1A2021"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2535 8.19148L17.3847 9.41797V16.3914H18.9231V9.37294L18.2535 8.19148ZM17.6378 6.35814C17.9979 5.84976 18.7372 5.88944 19.0456 6.43372L20.3434 8.72352C20.4207 8.86006 20.4616 9.01585 20.4616 9.17457V17.1153C20.4616 17.6039 20.0827 18 19.6154 18H16.6923C16.225 18 15.8462 17.6039 15.8462 17.1153V9.17907C15.8462 8.98944 15.9045 8.80482 16.0124 8.65244L17.6378 6.35814Z",
    fill: "#1A2021"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10.7611C2 10.3169 2.3444 9.95679 2.76923 9.95679H21.2308C21.6556 9.95679 22 10.3169 22 10.7611C22 11.2053 21.6556 11.5654 21.2308 11.5654H2.76923C2.3444 11.5654 2 11.2053 2 10.7611Z",
    fill: "#1A2021"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13.9783C2 13.5341 2.3444 13.174 2.76923 13.174H21.2308C21.6556 13.174 22 13.5341 22 13.9783C22 14.4225 21.6556 14.7826 21.2308 14.7826H2.76923C2.3444 14.7826 2 14.4225 2 13.9783Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFence);
export default __webpack_public_path__ + "static/media/fence.ce5db5f44b5bbc266110a5af7e0ee1f7.svg";
export { ForwardRef as ReactComponent };